interface SpeechToTextOptions {
  lang?: string;
  continuous?: boolean;
  onFinalResult?: (text: string) => void;
}

export function useSpeechToText(options: SpeechToTextOptions = {}) {
  const isListening = ref(false);
  const interimTranscript = ref('');
  const error = ref<string | null>(null);
  const isSupported = !!(window as any).SpeechRecognition || !!(window as any).webkitSpeechRecognition;

  let recognition: any = null;

  const stop = () => recognition?.stop();

  const start = () => {
    if (!isSupported || isListening.value) return;

    const SR = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

    recognition = new SR();
    recognition.lang = options.lang ?? 'en-US';
    recognition.continuous = options.continuous ?? true;
    recognition.interimResults = true;

    recognition.onstart = () => {
      isListening.value = true;
      error.value = null;
    };

    recognition.onresult = (event: any) => {
      let interim = '';

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];

        if (result.isFinal) {
          options.onFinalResult?.(result[0].transcript.trim());
        } else {
          interim += result[0].transcript;
        }
      }

      interimTranscript.value = interim;
    };

    recognition.onerror = (event: any) => {
      error.value = event.error;
      isListening.value = false;
      interimTranscript.value = '';
    };

    recognition.onend = () => {
      isListening.value = false;
      interimTranscript.value = '';
    };

    recognition.start();
  };

  const toggle = () => (isListening.value ? stop() : start());

  onUnmounted(() => recognition?.stop());

  return { isListening, interimTranscript, error, isSupported, start, stop, toggle };
}
